import { _ } from "i18n";
import { Download } from "lucide-react";
import type {
	GPDownloadTypeResponse
} from "../../types";
import { useEffect, useRef, useState } from "react";

interface DownloadTeamSheetProps {
	types: GPDownloadTypeResponse[];
	handleTeamSheetDataExport: (type: string) => void;
}

function getDownloadLabel(type: string, fallbackLabel: string): string {
	switch (type) {
		case "csv":
			return _("teamsheet.download.csv");
		case "pdf":
			return _("teamsheet.download.pdf");
		case "xlsx":
			return _("teamsheet.download.xlsx");
		default:
			return fallbackLabel;
	}
}

export function DownloadTeamSheet({ types, handleTeamSheetDataExport }: DownloadTeamSheetProps) {
	const [showOptions, setShowOptions] = useState(false);
	const [disabledTypes, setDisabledTypes] = useState<{ [types: string]: boolean }>({});
	const ref = useRef(null);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (ref.current && !(ref.current as HTMLElement).contains(event.target as Node)) {
				setShowOptions(false);
			}
		}
		document.addEventListener("mousedown", handleClickOutside, { passive: true });

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	if (types.length === 0) {
		return;
	}

	return (
		<div ref={ref}>
			<button type="button" className="download-button" onClick={() => setShowOptions(!showOptions)}>
				<Download size={24} strokeWidth={1.5} />
			</button>
			{showOptions && (
				<div
					className="download-options"

				>
					{
						types.map((link) => {
							return (
								<a
									key={link.type}
									className={`download-item ${disabledTypes[link.type] ? 'disabled' : ''}`}
									href="#"
									onClick={(e) => {
										if (disabledTypes[link.type]) {
											e.preventDefault();
											return;
										}

										setDisabledTypes((prev) => ({
											...prev,
											[link.type]: true
										}));

										handleTeamSheetDataExport(link.type)

										setTimeout(() => {
											setDisabledTypes((prev) => ({
												...prev,
												[link.type]: false
											}));
										}, 3000);
									}}
								>
									{getDownloadLabel(link.type, link.title)}
								</a>
							);
						})}
				</div>
			)}
		</div>
	);
}
